<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage stocks</div>
            <fieldset class="border p-3">
              <button class="btn btn-success btn-roundec" @click="loadStock()">
                <i class="fa fa-file-pdf-o"></i> STOCK STATUS
              </button>
              <p></p>
              <button class="btn btn-success btn-roundec" @click="loadRStock()">
                <i class="fa fa-file-pdf-o"></i> ORDER STOCK
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="stocksLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading stocks...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemStocks"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                ></vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment, { now } from "moment";
export default {
  data() {
    return {
      columns: [
        {
          label: "Product number",
          field: "product_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod number",
          },
        },
        {
          label: "Product name",
          field: "product_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod name",
          },
        },
        {
          label: "Product description",
          field: "product_description",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod description",
          },
        },
        {
          label: "measurement",
          field: "product_measurement",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod measurement",
          },
        },
        {
          label: "Selling price",
          field: "selling_price",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter selling price",
          },
        },
        {
          label: "Stock qty",
          field: "balance_stock",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter in stock",
          },
        },
      ],
    };
  },

  created() {
    this.loadStocks();
  },
  computed: {
    ...mapGetters(["systemStocks"]),
  },
  methods: {
    ...mapActions(["loadStocks", "loadStock", "loadRStock"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/stocks/managestocks.vue